import { Card } from "flowbite-react";

const CardDesign = () => {
  return (
    <Card
      className="max-w-full h-64"
      imgSrc={process.env.PUBLIC_URL + "/Widget.jpeg"}
      theme={{ root: { 
        base: "h-full",
        children: "-z-10" },
      img: { base: "rounded-md h-full" }}}
    >
      {/* <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
        <p>Noteworthy technology acquisitions 2021</p>
      </h5>
      <div className="font-normal text-gray-700 dark:text-gray-400">
        <p>
          Here are the biggest enterprise technology acquisitions of 2021 so
          far, in reverse chronological order.
        </p>
      </div> */}
    </Card>
  );
};

export default CardDesign;
